'use strict';

var ChartExampleViewport = function ChartExampleViewport(ChartViewport, chartGroups, chartTiles, chartSimpleBars) {
  var chartParams = require('./ParamsViewport');
  var chartScales = require('./Scales');
  var Chart = function Chart(container) {
    var groups = chartGroups('d1');
    var tiles = chartTiles('d1', 'm2');
    var simpleBars = chartSimpleBars('m1');
    ChartViewport.call(this, container, chartParams, chartScales, groups, simpleBars, tiles);
  };
  Chart.prototype = Object.create(ChartViewport.prototype);
  Chart.constructor = Chart;
  return Chart;
};
ChartExampleViewport.$inject = ['ChartViewport', 'ChartElementsGroup', 'ChartElementsTiles', 'ChartElementsSimpleBars'];
module.exports = ChartExampleViewport;